/**
 * Phase 66 Plan 02 — Topbar.
 *
 * Composition slots:
 *   - left: <Breadcrumb /> (drives off route handle.breadcrumb metadata)
 *   - right: tenant switcher slot (Plan 06 fills) + <UserMenu />
 *
 * Class + id contract preserved per 66-TESTID-CONTRACT.md / Phase 65:
 *   #topbar (id), .topbar (class), .topbar-right (right side wrapper)
 *
 * @see PATTERNS.md §Layout chrome — `<Topbar>` (was index.html lines 47-54)
 */

import Breadcrumb from "./Breadcrumb";
import UserMenu from "./UserMenu";
import PowerInstabilityBadge from "@/components/PowerInstabilityBadge";
import PrinterOfflineBadge from "@/components/PrinterOfflineBadge";
import RebootLoopBadge from "@/components/RebootLoopBadge";
import StaleBadge from "@/components/StaleBadge";
import TenantSwitcher from "@/components/TenantSwitcher";

export default function Topbar() {
  return (
    <header
      id="topbar"
      data-testid="topbar"
      className="topbar col-start-2 row-start-1 flex items-center justify-between px-6 border-b border-[color:var(--color-border)] bg-surface"
    >
      <Breadcrumb />
      <div className="topbar-right flex items-center gap-3">
        {/* Phase 68 D-OFF-03 channel 1 — fleet-wide power-instability badge.
            Mounted BEFORE the stale badge so the higher-severity Phase 68
            signal lands closer to the eye-line of the right edge. */}
        <div data-testid="power-instability-badge-slot">
          <PowerInstabilityBadge />
        </div>
        {/* Phase 67-01 D-04 — fleet-wide stale-kiosk badge */}
        <div data-testid="stale-badge-slot">
          <StaleBadge />
        </div>
        {/* Phase 67-07b — fleet-wide reboot-loop badge */}
        <div data-testid="reboot-loop-badge-slot">
          <RebootLoopBadge />
        </div>
        {/* Phase 83-05 (PRREC-03) — fleet-wide printer-offline badge (non-blocking) */}
        <div data-testid="printer-offline-badge-slot">
          <PrinterOfflineBadge />
        </div>
        {/* Plan 06 D-13 — TenantSwitcher mounted here. */}
        <div data-testid="tenant-switcher-slot">
          <TenantSwitcher />
        </div>
        <UserMenu />
      </div>
    </header>
  );
}
